/**
 * @fileoverview Suffix options for name suffixes in the GEAO onboarding process.
 * Contains predefined suffix values that users can select from.
 * 
 * @module SuffixOptions
 * @since 1.0.0
 */

/**
 * @typedef {Object} SuffixOption
 * @property {string} value - The internal value used for the suffix (lowercase, empty string for none)
 * @property {string} label - The display label shown to the user
 */

/**
 * Frozen array of suffix options available for selection during onboarding.
 * Includes common name suffixes like Jr., Sr., and Roman numerals.
 * 
 * @type {ReadonlyArray<SuffixOption>}
 * @constant
 * @default
 * 
 * @example
 * // Usage in a select component
 * import SuffixOptions from './SuffixOptions';
 * 
 * SuffixOptions.forEach(option => {
 *   console.log(`${option.label}: ${option.value}`);
 * });
 * // Output:
 * // None: 
 * // Jr.: jr
 * // Sr.: sr
 * // II: ii
 * // III: iii
 */
export default Object.freeze([
    { value: "", label: "None" },
    { value: "jr", label: "Jr." },
    { value: "sr", label: "Sr." },
    { value: "ii", label: "II" },
    { value: "iii", label: "III" }
]);